import intl from "react-intl-universal";
import { LabelButton } from 'components/label-button';
import { FileUploadDynamicInventoryPolicy } from 'components/file-upload/file-upload-dynamic-inventory-policy';
import { Step2DynamicInventoryPolicyProps } from "../dynamic-inventory-policy-types";

const Step2DynamicInventoryPolicy: React.FC<Step2DynamicInventoryPolicyProps> = ({ errors, contextModal, noMessageExample, downloadModelFile, startFetching, stopFetching, handleReadFile, setCsv, setErrors, setFileName }) => {
  const handleDownloadModelFile = async () => {
    try {
      startFetching();
      await downloadModelFile();
    } catch (e) {
      console.error('Error occurred while downloading the model file:', e);
    } finally {
      stopFetching();
    }
  };

  return (
    <div className={`content ${errors ? "error-state" : ""}`}>
      <span className="title">
        {intl.get(`exportImportModal.${contextModal}.messageStep2`)}
      </span>
      <LabelButton
        className="title link"
        data-testid="download-model-import"
        onClick={handleDownloadModelFile}
      >
        {!noMessageExample &&
          intl.get(`exportImportModal.${contextModal}.downloadModelMessage`)}
      </LabelButton>
      <FileUploadDynamicInventoryPolicy
        handleReadFile={handleReadFile}
        setCsv={setCsv}
        setErrors={setErrors}
        setFileName={setFileName}
      />
      {!!errors.length && (
        <div className="errors-content">
          <p>{intl.get("master-data.general-configuration.uploadErrors")}</p>
          <ul>
            {errors.map((x) => (
              <li key={x}>{x}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Step2DynamicInventoryPolicy;
